var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DebugButton --global-clickable",style:(_vm.position),on:{"click":function($event){return _vm.openMenu()}}})}
var staticRenderFns = []

export { render, staticRenderFns }